import { FC } from 'react';
import { getLoanStatusNameFromLoanStatusId } from '../../helpers';

type Props = {
  status: number;
};
const LoanStatusBadge: FC<Props> = ({ status }) => {
  const loanStatus = getLoanStatusNameFromLoanStatusId(status);
  return <span className={`badge badge-light-${loanStatus} fs-7 fw-bold mx-2`}>{loanStatus}</span>;
};

export default LoanStatusBadge;
